export default __webpack_public_path__ + "static/media/footer_image_3.8e9886c5.jpg";